import { Expose, Transform, Type } from 'class-transformer'
import moment from 'moment'

import { Batch } from './Batch'
import { Container } from './Container'
import { Facility } from './Facility'
import { Place } from './Place'
import { Product } from './Product'
import { Sku } from './Sku'

export class UnitLoc {
  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Type(() => Facility)
  facility?: Facility

  @Type(() => Place)
  place?: Place

  @Type(() => Container)
  container?: Container

  @Type(() => Batch)
  batch?: Batch

  get location() {
    return this.container || this.place || null
  }

  @Expose({ name: 'num_units' })
  numUnits?: number

  @Expose({ name: 'date_received' })
  @Transform((value) => moment(value))
  dateReceived?: moment.Moment

  get path() {
    if (this.location) {
      return this.location.path
    }
    return null
  }

  get objPath() {
    if (this.location) {
      return this.location.objPath
    }
    return null
  }
}
